type GeneratePaymentLinkResult = {
  data?: { generatePaymentLink?: { link?: string | null } | null } | null;
  error?: { graphQLErrors?: Array<{ message?: string }> } | null;
};

export const ALREADY_PAID_MESSAGE =
  "Ta rata jest już opłacona. Odśwież stronę, żeby zobaczyć aktualny stan zamówienia.";
export const GENERIC_ERROR_MESSAGE =
  "Nie udało się przejść do płatności. Spróbuj ponownie za chwilę, a jeśli problem się powtórzy, skontaktuj się z biurem.";

const messageFor = (result: GeneratePaymentLinkResult) =>
  result.error?.graphQLErrors?.some(({ message }) =>
    message?.includes("already paid")
  )
    ? ALREADY_PAID_MESSAGE
    : GENERIC_ERROR_MESSAGE;

/**
 * "Zapłać" (SCRUM-157): one request at a time, the redirect is taken straight from the mutation
 * result, and the customer always gets either P24 or a visible error — the button never just
 * stays silent. `inFlight` is a ref kept by the component, so it survives re-renders.
 */
export const payOnce = async (
  inFlight: { current: boolean },
  deps: {
    request: () => Promise<GeneratePaymentLinkResult>;
    navigate: (link: string) => void;
    setBusy: (busy: boolean) => void;
    onError: (message: string, details: unknown) => void;
  }
): Promise<void> => {
  if (inFlight.current) return;
  inFlight.current = true;
  deps.setBusy(true);
  try {
    const result = await deps.request();
    const link = result.data?.generatePaymentLink?.link;
    if (link) {
      // Stays busy until the browser leaves for P24
      deps.navigate(link);
      return;
    }
    deps.onError(messageFor(result), result.error ?? "no link in the response");
  } catch (error) {
    deps.onError(GENERIC_ERROR_MESSAGE, error);
  }
  inFlight.current = false;
  deps.setBusy(false);
};
